<ng-container *transloco="let t">
    <div class="chapter mt-1">
        <p class="fw-medium fs-28">
            {{t('policy.complaints.and.disputes.chapter.1.title')}}
        </p>
        <p>{{t('policy.complaints.and.disputes.chapter.1.1')}} <a href="mailto: {{environment.complaintsMail}}">
            {{environment.complaintsMail}}</a>
        </p>
        <p>{{t('policy.complaints.and.disputes.chapter.1.2')}}
        </p>
    </div>

    <div class="chapter mt-3">
        <p class="fw-medium fs-28">
            {{t('policy.complaints.and.disputes.chapter.2.title')}}
        </p>
        <p>{{t('policy.complaints.and.disputes.chapter.2.1')}}
        </p>
    </div>

</ng-container>
